// Library
import { createSlice } from '@reduxjs/toolkit';

import { reportFilters } from '..';

export const reportFilterSlice = createSlice({
    name: 'reportfilters',
    initialState: {
        reportFilter: reportFilters
    },
    reducers: {
        // updates selected district info
        setDistrictFilter: (state, action) => {
            state.reportFilter.district = action.payload;
        },
        // updates selected block info
        setBlockFilter: (state, action) => {
            state.reportFilter.block = action.payload;
        },
        // updates selected school info
        setSchoolFilter: (state, action) => {
            state.reportFilter.school = action.payload;
        },
        setGradeFilter: (state, action) => {
            state.reportFilter.grade = action.payload;
        },
        setStartDateFilter: (state, action) => {
            state.reportFilter.start_date = action.payload;
        },
        setEndDateFilter: (state, action) => {
            state.reportFilter.end_date = action.payload;
        },
        setSlotFilter: (state, action) => {
            state.reportFilter.slot = action.payload;
        },
    }
});

// Action creators are generated for each case reducer function
export const {
    setDistrictFilter,
    setBlockFilter,
    setSchoolFilter,
    setGradeFilter,
    setStartDateFilter,
    setEndDateFilter,
    setSlotFilter,
} = reportFilterSlice.actions;
export default reportFilterSlice.reducer;